import { RecipesCategories } from "../modules/recipesCategories";

export const RecipesCategoriesPage = () => {
  return <RecipesCategories />;
};
